var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosiChargeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.843,
    height: 49.355,
    viewBox: "0 0 233.843 49.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PosiCharge_Vector",
    "data-name": "PosiCharge Vector",
    transform: "translate(116.922 24.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(-116.922 -24.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(226.077 4.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5102",
    "data-name": "Path 5102",
    d: "M1048.036,24.078V20.661h-1.22v-.7h3.269v.7h-1.218v3.417Z",
    transform: "translate(-1046.816 -19.965)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5103",
    "data-name": "Path 5103",
    d: "M1064.38,24.078V19.965h1.243l.746,2.806.738-2.806h1.246v4.113h-.772V20.841l-.816,3.238h-.8l-.813-3.238v3.238Z",
    transform: "translate(-1060.587 -19.965)",
    fill: "#004f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5104",
    "data-name": "Path 5104",
    d: "M936.5.882l-.953,2.723h4.811l.953-2.723Z",
    transform: "translate(-733.504 -0.692)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M1005.85.882l-.953,2.723h4.811l.953-2.723Z",
    transform: "translate(-787.873 -0.692)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(70.907 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M345.929,17.213h-11.7l4.3-12.764h11.827L351.935,0H340.2q-5.427,0-6.723,3.717c-.921,2.664-4.91,14.489-4.91,14.489-.846,2.478.51,3.737,4.127,3.737h11.581Z",
    transform: "translate(-328.323 -0.001)",
    fill: "#004f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M417.713,20.6h5.2l-2.19,6.5h7.892l2.2-6.5h5.341l-5.918,17.475H424.9l2.206-6.443h-7.893L417,38.072h-5.2Z",
    transform: "translate(-322.867 -16.148)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5108",
    "data-name": "Path 5108",
    d: "M500.7,38.072h6.28l1.592-2.54h7.133l-.025,2.562h5.459l.138-17.5h-8.651Zm15.161-7.222h-4.234l4.414-6.868Z",
    transform: "translate(-392.567 -16.15)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5109",
    "data-name": "Path 5109",
    d: "M618.875,25.174l-.63,2.005H610.03l.648-2.005ZM620.3,20.6H606.815l-5.87,17.5h5.162l2.188-6.341h3.658l2.685,6.341h5.648l-2.7-6.376c2.94-.257,4.795-1.529,5.563-3.731l1.08-3.073h0c.068-.2.135-.387.2-.573.865-2.475-.5-3.741-4.123-3.741",
    transform: "translate(-471.161 -16.149)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5110",
    "data-name": "Path 5110",
    d: "M724.425,25.054l1.54-4.459H712.571q-5.427,0-6.723,3.717c-.922,2.664-3.4,10.042-3.4,10.042-.845,2.478.569,3.742,4.184,3.742h13.233l3.255-9.246h-5.154l-1.614,4.509h-8.246l2.8-8.305Z",
    transform: "translate(-550.556 -16.147)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5111",
    "data-name": "Path 5111",
    d: "M19.565,4.448l-2.256,6.582H9.094L11.37,4.448ZM20.909,0H7.472L0,21.944H5.161l2.19-6.349c.1,0,8.62.008,8.62.008,3.34,0,5.41-1.4,6.238-3.767l2.658-7.5h0c.068-.2.136-.388.2-.573C25.933,1.291,24.526,0,20.909,0",
    fill: "#004f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5112",
    "data-name": "Path 5112",
    d: "M295.221,20.6h5.267l-5.972,17.5h-5.162Z",
    transform: "translate(-226.863 -16.148)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(21.827 4.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5113",
    "data-name": "Path 5113",
    d: "M216.75,20.6H203.444q-5.427,0-6.723,3.717l-.052.17L195.5,27.908c-.773,2.209.311,3.627,3.833,3.709l.008.011h8.381l-.618,1.758-13.562,0-1.661,4.7h13.905c3.34.006,5.413-1.479,6.241-3.849l1.144-3.372c.865-2.475-.54-3.717-4.158-3.717h0l-8.08,0,.7-1.956h13.535Z",
    transform: "translate(-172.267 -20.597)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5114",
    "data-name": "Path 5114",
    d: "M820.024,25.056l1.583-4.458H808.161c-3.618,0-5.849,1.239-6.713,3.717-.922,2.664-3.4,10.042-3.4,10.042-.847,2.478.56,3.737,4.177,3.737h13.252l1.634-4.726-13.4-.006.631-1.873h13.473l1.529-4.494H805.849l.652-1.939Z",
    transform: "translate(-647.336 -20.598)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5115",
    "data-name": "Path 5115",
    d: "M117.9,25.215l-2.821,8.194H106.86l2.84-8.194ZM119.29,20.6h-7.86q-5.425,0-6.722,3.717c-.659,1.9-.663,1.9-3.4,9.977-.846,2.478.544,3.8,4.161,3.8h8.269c3.322,0,5.45-1.479,6.278-3.849,0,0,3.364-9.7,3.429-9.883.831-2.449-.536-3.764-4.152-3.764",
    transform: "translate(-101.066 -20.597)",
    fill: "#004f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5116",
    "data-name": "Path 5116",
    d: "M395.848,41.663,397.323,20.6l8.549,26.767L253.01,41.519Z",
    transform: "translate(-198.368 -16.152)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5117",
    "data-name": "Path 5117",
    d: "M343.251,20.6l13.15,21.21-5.443-.01,2.173,6.57L184.044,41.832l173.379,11.3L368.809,20.6Z",
    transform: "translate(-144.297 -16.148)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(152.445 38.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5118",
    "data-name": "Path 5118",
    d: "M758.227,185.442a1.856,1.856,0,1,1,3.661,0c0,1.215-.382,2.516-1.838,2.516s-1.823-1.314-1.823-2.516m-1.979.226a3.81,3.81,0,0,0,7.619,0,3.81,3.81,0,1,0-7.619,0m-4.41,1.4a2.141,2.141,0,0,0,2.3,2.361,4.97,4.97,0,0,0,1.4-.17l-.056-1.5a1.689,1.689,0,0,1-.862.2c-.721,0-.891-.58-.891-1.2v-3.392h1.682v-1.385h-1.682v-2.064l-1.894.608v1.456h-1.4v1.385h1.4Zm-2.445-4.99a8.746,8.746,0,0,0-2.063-.268c-1.484,0-2.855.693-2.855,2.262,0,2.629,3.293,1.654,3.293,3.081,0,.707-.763.891-1.244.891a4.156,4.156,0,0,1-1.866-.481l-.113,1.555a8.479,8.479,0,0,0,2.148.311c1.54,0,3.053-.679,3.053-2.375,0-2.63-3.294-1.894-3.294-3.054,0-.622.608-.806,1.117-.806a4.648,4.648,0,0,1,1.7.311Zm-10.968,5.074c0-1.116,1.258-1.258,2.106-1.258h.82a2.412,2.412,0,0,1-.4,1.5,1.607,1.607,0,0,1-1.328.65c-.679,0-1.2-.269-1.2-.891m-.961-3.166a3.81,3.81,0,0,1,2.247-.792c1.117,0,1.639.4,1.639,1.569H740.3a5.761,5.761,0,0,0-2.445.424,2.139,2.139,0,0,0-1.244,2.078,2.322,2.322,0,0,0,2.544,2.163,2.6,2.6,0,0,0,2.248-1.258h.028a8.894,8.894,0,0,0,.084,1.089h1.668c-.042-.565-.071-1.074-.085-1.625s-.028-1.089-.028-1.824v-.932c0-2.149-.919-3.068-3.138-3.068a6.517,6.517,0,0,0-2.53.551Zm-9.018,5.272h1.837v-.891h.028a2.662,2.662,0,0,0,2.234,1.061c2.233,0,3.053-1.837,3.053-3.831s-.82-3.788-3.053-3.788a2.548,2.548,0,0,0-2.177,1.1h-.028v-4.255h-1.894Zm1.909-3.661c0-1.018.48-2.318,1.7-2.318s1.569,1.342,1.569,2.318c0,1-.354,2.361-1.6,2.361s-1.667-1.328-1.667-2.361m-3.93,1.71a4.915,4.915,0,0,1-2.418.735,1.9,1.9,0,0,1-2.077-1.838h5.032c0-2.544-.763-4.4-3.463-4.4-2.262,0-3.379,1.739-3.379,3.845a3.459,3.459,0,0,0,3.8,3.774,5,5,0,0,0,2.5-.58Zm-4.495-2.4a1.649,1.649,0,0,1,1.682-1.71c1.06,0,1.484.792,1.541,1.71Zm-13.443,4.353h2.559l1.753-7.887h.028l1.781,7.887h2.544l2.573-9.866H717.8l-1.852,7.887h-.028l-1.739-7.887H711.5l-1.682,7.887h-.028l-1.838-7.887h-2.078Z",
    transform: "translate(-705.872 -178.657)",
    fill: "#004f9f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosiChargeLogo);
export default __webpack_public_path__ + "static/media/PosiChargeLogo.fd1da56b5b0393bd654cfd5c726993fa.svg";
export { ForwardRef as ReactComponent };